module.exports = __webpack_public_path__ + "components/page-header/static/icon-heart-13263831f0b37c4e798d589535a4dde2.svg";